import { services } from './service/services';

export const isMock = () => {
  return services.getUrlService().isMock();
};